import gsap from 'gsap'
import store from '@/store'
import { playUnlock } from '@/lib/sound.js'

let velocity
let t
let angle
let spinInterval
let accelerating = false

function updateButtonRotation(id, angle) {
  const button = document.getElementById(id)
  button.style.transform = `rotate(${angle}deg)`
}

function clearButtonStyles(id) {
  console.log('clearButtonStyles: ', id)
  const button = document.getElementById(id.replace('#', ''))
  /*button.style.transform = null
  button.style.color = null
  button.style.borderColor = null*/
  button.style = null
}

function spinner() {
  store.commit('SET_BLOCK_CLICKS', [1, 2, 3, 5, 6, 7, 8, 9])
  const nine_index = store.getters.button_vals.findIndex((x) => x == '9')
  const button_id = `button-${nine_index + 1}`

  /*const secondClick = () => {
    console.log('secondClick')
    const controlButton = document.getElementById('button-4')*/

  if (accelerating) {
    gsap.from('#' + button_id, {
      // #FF3633
      backgroundColor: 'rgba(100,21,20,0.3)',
      duration: 0.3,
    })
    return
  }

  /*controlButton.removeEventListener('mousedown', secondClick)
    controlButton.removeEventListener('touchstart', secondClick)*/

  if (spinInterval !== undefined) {
    clearInterval(spinInterval)
    spinInterval = undefined

    if (Math.abs((angle % 360) - 180) < 20) {
      console.log('TRIGGERED')
      tween_unlock_progress({ to: 100, duration: 0.5 })
      triggered()
    } else {
      tween_unlock_progress({ to: 66, duration: 0.5 })
      const tl = gsap.timeline()
      tl.from('#' + button_id, {
        color: '#468B18',
        borderColor: '#468B18',
        duration: 0.5,
        ease: 'power4.in',
        clearProps: true,
      })
      tl.fromTo(
        '#' + button_id,
        {
          rotate: angle % 360,
          duration: 1,
        },
        {
          rotate: 360,
          onComplete: () => {
            unlockProgress.progress = 0
            store.commit('SET_BLOCK_CLICKS', [])
          },
        }
      )
    }
    return
  }

  tween_unlock_progress({ to: 33, duration: 0.5 })
  //}

  /*const controlButton = document.getElementById('button-4')
  controlButton.addEventListener('mousedown', secondClick)
  controlButton.addEventListener('touchstart', secondClick)*/

  velocity = 0
  t = 0
  angle = 0
  const acceleration = 0.1
  console.log('acclerating: true')
  accelerating = true

  spinInterval = setInterval(() => {
    // 10.8 = 3 rotations/sec at 10ms increments
    velocity = Math.min(t * acceleration, 10.8)
    angle += velocity
    t += 1
    updateButtonRotation(button_id, angle)
  }, 10)

  const mouseup_listener = function () {
    console.log('mouseup')
    window.removeEventListener('mouseup', mouseup_listener)
    window.removeEventListener('touchend', mouseup_listener)
    setTimeout(() => {
      console.log('acclerating: false')
      accelerating = false
      clearInterval(spinInterval)

      t = 0
      const start_velocity = velocity
      const start_angle = angle

      let end_rotations
      if (start_velocity < 3) {
        end_rotations = 0
      } else if (start_velocity >= 3 && start_velocity <= 8) {
        end_rotations = 1
      } else {
        end_rotations = 3
      }
      const d = 360 * (end_rotations + 1) - (angle % 360)
      const deceleration = start_velocity ** 2 / (2 * d)
      const end_t = (2 * d) / start_velocity

      console.log('start velocity: ', velocity)
      console.log('start angle: ', angle)
      console.log('d: ', d)
      console.log('deceleration: ', deceleration)

      spinInterval = setInterval(() => {
        angle = start_angle - (deceleration / 2) * t ** 2 + start_velocity * t
        t = Math.min(t + 1, end_t)
        if (t >= end_t) {
          console.log('DONE')
          clearInterval(spinInterval)
          spinInterval = undefined
          //updateButtonRotation(button_id, start_angle + d)
          clearButtonStyles(button_id)
          store.commit('SET_BLOCK_CLICKS', [])
          unlockProgress.progress = 0
        } else {
          updateButtonRotation(button_id, angle)
        }
      }, 10)
    }, (50 - t) * 10)
  }

  window.addEventListener('mouseup', mouseup_listener)
  window.addEventListener('touchend', mouseup_listener)
}

function triggered() {
  const unlocking = !store.getters.isActionUnlocked('spinner')
  if (!unlocking) {
    store.commit('SET_MOVE_NAME_ANIMATE', store.getters.actions['spinner'])
  }

  store.commit('SET_BLOCK_CLICKS', [1, 2, 3, 4, 5, 6, 7, 8, 9])

  setTimeout(() => {
    unlockProgress.progress = 0
  }, 700)

  const nine_index = store.getters.button_vals.findIndex((x) => x == '9')
  const nine_button_id = `#button-${nine_index + 1}`
  const six_index = store.getters.button_vals.findIndex((x) => x == '6')
  const six_button_id = `#button-${six_index + 1}`

  const tl = gsap.timeline()

  /*gsap.fromTo(
    [nine_button_id, six_button_id],
    { y: -5 },
    {
      y: 5,
      duration: 0.05,
      repeat: 5,
      yoyo: true,
      ease: 'Sine.easeInOut',
      onComplete: function () {
        gsap.to([nine_button_id, six_button_id], {
          y: 0,
          duration: 0.5,
          ease: 'Elastic.easeOut',
        })
      },
    }
  )*/

  setTimeout(() => {
    let new_vals = [...store.getters.button_vals]

    new_vals[six_index] = '9'
    new_vals[nine_index] = '6'

    /* Switch up the content directly before updated via vuex to avoid flicker */
    const six_el = document.getElementById(six_button_id.replace('#', ''))
    //six_el.style.display = 'none'
    six_el.innerText = '9'
    gsap.set(six_button_id, {
      rotate: -180,
    })
    //six_el.style.display = 'flex'

    const nine_el = document.getElementById(nine_button_id.replace('#', ''))
    //nine_el.style.display = 'none'
    nine_el.innerText = '6'
    gsap.set(nine_button_id, {
      rotate: 0,
    })

    //nine_el.style.display = 'flex'

    store.commit('SET_BUTTON_VALS', new_vals)

    //clearButtonStyles(nine_button_id)
    //clearButtonStyles(six_button_id)
  }, 100)

  tl.fromTo(
    [nine_button_id, six_button_id],
    { y: -5 },
    {
      y: 5,
      duration: 0.05,
      repeat: 5,
      yoyo: true,
      ease: 'Sine.easeInOut',
    },
    'at_once'
  )

  tl.to(
    [nine_button_id, six_button_id],
    {
      y: 0,
      duration: 0.5,
      delay: 0.25,
      ease: 'Elastic.easeOut',
      onComplete: () => {
        if (unlocking) {
          playUnlock()
        }
      },
    },
    'at_once'
  )

  tl.from(
    [nine_button_id, six_button_id],
    {
      color: '#468B18',
      borderColor: '#468B18',
      duration: 0.5,
      delay: unlocking ? 1.5 : 0.5,
      ease: 'power4.in',
    },
    'at_once'
  )

  /*tl.fromTo(
    nine_button_id,
    {
      rotate: angle % 360,
      duration: 0,
    },
    { rotate: 180 },
    'at_once'
  )*/

  tl.to(six_button_id, {
    rotate: 0,
    duration: 1,
    ease: 'bounce',
    onComplete: () => {
      store.dispatch('rerender')
      if (unlocking) {
        store.dispatch('unlock_action', 'spinner')
        setTimeout(() => {
          store.commit('SET_SHOW_UNLOCK_DIALOG', true)
        }, 500)
      } else {
        store.commit('SET_BLOCK_CLICKS', [])
      }
    },
  })
  /*tl.set(nine_button_id, {
    clearProps: 'rotate,x,y,color,borderColor',
  })*/
  /*tl.fromTo(
    six_button_id,
    {
      rotate: 0,
    },
    {
      rotate: 180,
      duration: 1,
      ease: 'bounce',
      clearProps: true,
      onComplete: () => {
        let new_vals = [...store.getters.button_vals]

        new_vals[six_index] = '9'
        new_vals[nine_index] = '6'

        store.commit('SET_BUTTON_VALS', new_vals)
        clearButtonStyles(nine_button_id)
        clearButtonStyles(six_button_id)
      },
    }
  )*/
}

const unlockProgress = {
  _progress: 0,
  set progress(val) {
    store.commit('SET_UNLOCK_PROGRESS', +val)
    this._progress = +val
    //console.log('tweened to:', +val)
  },
  get progress() {
    return this._progress
  },
}

function tween_unlock_progress(vals) {
  //console.log('tween_unlock_progress:', vals)
  //console.log(unlockProgress.progress)
  gsap.to(unlockProgress, {
    progress: vals.to,
    duration: vals.duration,
  })
}

export default spinner
